import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

import { AppStoreModule } from '@/store';
import { OnboardingRegistrationSummary } from '@/common/models';
import IAdminService from '@/services/http/interfaces/IAdminService';
import { OnboardingRegistrationStatus } from '@/common/viewModels/Enums';
import { ErrorHelper } from '@/common/helpers';

export interface IRegistrationsState {
  onboardingRegistrations: OnboardingRegistrationSummary[];
  filter: string;
  currentPage: number;
  registrationStatusFilter: OnboardingRegistrationStatus[];
}

@Module({
  name: 'registrations',
  namespaced: true,
})
export default class RegistrationsStore extends VuexModule implements IRegistrationsState {
  // State
  onboardingRegistrations: OnboardingRegistrationSummary[] = [];
  filter: string = '';
  currentPage = 0;
  // Default to 'New' and 'In progress' on startup
  registrationStatusFilter: OnboardingRegistrationStatus[] = [OnboardingRegistrationStatus.Submitted, OnboardingRegistrationStatus.Pending];

  // Getters
  get filteredOnboardingRegistrations(): OnboardingRegistrationSummary[] {

    const filterAsLowercase: string = this.filter.toLowerCase();

    return this.onboardingRegistrations.filter((or) =>
      (or.name.toLowerCase().includes(filterAsLowercase) ||
        or.email.toLowerCase().includes(filterAsLowercase) ||
        or.phone.toLowerCase().includes(filterAsLowercase)) &&
      (this.registrationStatusFilter.length === 0 || this.registrationStatusFilter.includes(or.status)),
    );
  }

  // Mutations
  @Mutation
  SET_ONBOARDING_REGISTRATION_SUMMARY(onboardingRegistrations: OnboardingRegistrationSummary[]) {
    this.onboardingRegistrations = onboardingRegistrations;
  }

  @Mutation
  SET_FILTER(filter: string) {
    this.currentPage = 0;
    this.filter = filter;
  }

  @Mutation
  SET_CURRENT_PAGE(currentPage: number) {
    this.currentPage = currentPage;
  }

  @Mutation
  SET_REGISTRATION_STATUS_FILTER(registrationStatusFilter: OnboardingRegistrationStatus[]) {
    this.currentPage = 0;
    this.registrationStatusFilter = registrationStatusFilter;
  }

  // Actions
  @Action
  async getRegistrations(adminService: IAdminService) {

    AppStoreModule.SET_ISLOADING(true);

    await adminService.getOnboardingRegistrations()
      .then((onboardingRegistrations: OnboardingRegistrationSummary[]) => {
        this.SET_ONBOARDING_REGISTRATION_SUMMARY(onboardingRegistrations);
      })
      .catch((e) => {
        AppStoreModule.SAVE_HTTP_ERROR(ErrorHelper.getMessageForError(e, 'Unable to load registrations'));
      })
      .finally(() => {
        AppStoreModule.SET_ISLOADING(false);
      });
  }

  @Action
  setFilter(filter: string) {
    this.SET_FILTER(filter);
  }

  @Action
  setCurrentPage(currentPage: number) {
    this.SET_CURRENT_PAGE(currentPage);
  }

  @Action
  setRegistrationStatusFilter(registrationStatusFilter: OnboardingRegistrationStatus[]) {
    this.SET_REGISTRATION_STATUS_FILTER(registrationStatusFilter);
  }
}
